/** The world's address and phone rules (LIS-1173), from
 *  `@libs/countries-contracts/world`, for this package's current callers. */
export * from "@libs/countries-contracts/world";
